import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "userName",
  "use": "userName-usage",
  "viewBox": "0 0 14 14",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 14 14\" id=\"userName\"><path fill=\"#37F\" fill-rule=\"nonzero\" d=\"M5.573 7.914c-2.385 0-4.166 1.546-4.166 3.79v.242c0 1.173 1.908 1.173 4.325 1.173h2.567c2.32 0 4.325 0 4.325-1.173v-.242c0-2.244-1.781-3.79-4.166-3.79H5.573Zm1.314-.59c1.889 0 3.426-1.447 3.426-3.226 0-1.778-1.537-3.225-3.426-3.225C4.998.873 3.46 2.32 3.46 4.098c0 1.779 1.537 3.226 3.426 3.226Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol